import { useTableBulkActions } from '@monorepo/shared/componentsV2/Table/useTableBulkActions';
import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 100%;
  padding: 1rem;
  color: ${({ theme }) => theme.colors.blue};
  text-align: center;
  background-color: ${({ theme }) => theme.colors.builderBlue16};
`;

type BulkDeleteLimitWarningProps = {
  pluralEntityLabel: string;
};

export function BulkDeleteLimitWarning({
  pluralEntityLabel,
}: BulkDeleteLimitWarningProps) {
  const {
    bulkRowDeleteLimit,
    isBulkActionsModeOn,
    isBulkDeleteLimitExceeded,
    selectedCount,
  } = useTableBulkActions();

  if (!isBulkActionsModeOn || !isBulkDeleteLimitExceeded) {
    return null;
  }

  return (
    <Container>
      {selectedCount} {pluralEntityLabel} selected. You can only delete up to{' '}
      {bulkRowDeleteLimit} {pluralEntityLabel} at a time.
    </Container>
  );
}
